import React from "react"
import { Query } from "react-apollo"
import { Link } from "react-router-dom"
import gql from "graphql-tag"
import { Waypoint } from "react-waypoint"
import SearchBar from "../../components/SearchBar"
import moment from "moment"
import sanitize from "sanitize-html"
import Loading from "../../components/Loading"
import { Redirect } from "react-router"

import "./Archive.scss"

const GET_POSTS = gql`
  query GET_POSTS($postType: PostType, $after: String, $search: String) {
    postsArchive(postType: $postType, after: $after, search: $search) {
      id
      title
      subtitle
      slug
      createdBy
      postType
      active
      seo
      publishDate
      headerImage {
        mobile {
          uri
        }
      }
    }
    viewer {
      id
      isUserAuthenticated
    }
  }
`

class Archive extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      search: "",
      filter: null,
      hasMore: true,
      postType: null,
    }
    this.typingTimer
    this.doneTypingInterval = 300
  }

  renderArchive = (postsArchive) => {
    if (postsArchive.length > 0) {
      return postsArchive.map((post, i) => {
        let publishDate = new Date(post.publishDate)
        return (
          <div key={i} className="postArchive-container--post">
            <Link to={`${post.slug[0]}`}>
              <div className="post-image">
                {post.headerImage && post.headerImage.mobile ? (
                  <img src={post.headerImage.mobile.uri} />
                ) : post.postType === "NEWS" ? (
                  <div className="newsletter-default">
                    <div className="newsletter-date">
                      {moment(publishDate).format("MMMM Do, YYYY")}
                    </div>
                    <div className="newsletter-text">Newsletter</div>
                  </div>
                ) : (
                  /* Default for article due to old articles not having header images */
                  <div className="newsletter-default">
                    <div className="newsletter-date">
                      {moment(publishDate).format("MMMM Do, YYYY")}
                    </div>
                    <div className="newsletter-text">Article</div>
                  </div>
                )}
              </div>
              <div className="post-desc">
                {post.title && post.postType != "NEWS" ? (
                  <div dangerouslySetInnerHTML={{ __html: post.title }}></div>
                ) : (
                  <div>
                    <p>Newsletter</p>
                  </div>
                )}
                {/* Sub Description for Articles only */}
                {post.postType === "ARTICLE" ? (
                  <div className="sub-desc">
                    <p>{post.subtitle ? post.subtitle : ""}</p>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(post.createdBy),
                      }}
                    />
                    <span> | </span>
                    <span style={{ color: "black" }}>
                      {moment(publishDate).format("MMMM YYYY")}
                    </span>
                  </div>
                ) : (
                  <div className="sub-desc">
                    <p>{moment(publishDate).format("MMMM Do, YYYY")}</p>
                  </div>
                )}
              </div>
            </Link>
          </div>
        )
      })
    } else {
      return (
        <div className="postArchive-container--noResults">No results found</div>
      )
    }
  }

  moreOnScroll = (data, fetchMore) => {
    return fetchMore({
      variables: {
        after:
          data.postsArchive &&
          data.postsArchive[data.postsArchive.length - 1].id,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          this.setState({ hasMore: false })
          return prev
        }
        return Object.assign({}, prev, {
          postsArchive: [
            ...(prev.postsArchive || []),
            ...(fetchMoreResult.postsArchive || []),
          ],
        })
      },
    })
  }

  loadMoreOnScroll = (data, fetchMore) => {
    if (data.postsArchive.length > 0) {
      this.moreOnScroll(data, fetchMore).catch(console.log)
      // load
    }
  }

  onFinishedTyping = (searchText) => {
    this.setState({ search: searchText })
  }

  onSearch = (e) => {
    e.persist()
    clearTimeout(this.typingTimer)
    this.typingTimer = setTimeout(
      () => this.onFinishedTyping(e.target.value),
      this.doneTypingInterval
    )
  }

  postTypeFilter = (type) => {
    if (this.state.postType != type) {
      this.setState({ postType: type })
    } else {
      this.setState({ postType: null })
    }
  }

  render() {
    if (!this.props.viewer || !this.props.viewer.isUserAuthenticated) {
      return (
        <Redirect
          to={{ pathname: "/login", state: { from: "/newsletters/archive" } }}
        />
      )
    }
    return (
      <div className="archive-container">
        <div className="archive-header">
          <h1 className="header-text">The Archive</h1>
          <SearchBar
            placeholder="Search our Archive... e.g. title, date(April 2019)"
            classes={["border", "rounded", "search"]}
            onKeyUp={this.onSearch}
          />
        </div>
        <div className="archive-body">
          <div style={{ paddingBottom: "10px" }}>
            <div style={{ textAlign: "center", paddingTop: "20px" }}>
              <p className="looking-txt">What are you looking for?</p>
              <div style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                <button
                  className={
                    this.state.postType === "ARTICLE"
                      ? "archive-active-btn"
                      : "archive-btn"
                  }
                  onClick={() => this.postTypeFilter("ARTICLE")}
                >
                  {" "}
                  Articles
                </button>
                <button
                  className={
                    this.state.postType === "NEWS"
                      ? "archive-active-btn"
                      : "archive-btn"
                  }
                  onClick={() => this.postTypeFilter("NEWS")}
                >
                  Newsletters
                </button>
              </div>
            </div>
            <Query
              query={GET_POSTS}
              variables={{
                search: this.state.search,
                postType: this.state.postType,
              }}
              fetchPolicy="network-only"
            >
              {({ loading, error, data, fetchMore }) => {
                if (loading) return <Loading />
                if (error) return `Error! ${error.message}`
                return (
                  <div className="postArchive-container">
                    {!loading && this.renderArchive(data.postsArchive)}
                    {this.state.hasMore && !loading && (
                      <Waypoint
                        onEnter={() => this.loadMoreOnScroll(data, fetchMore)}
                      />
                    )}
                  </div>
                )
              }}
            </Query>
          </div>
        </div>
      </div>
    )
  }
}

const sanitizeHtml = (dirty) => {
  return sanitize(dirty, {
    allowedTags: ["a"],
    allowedAttributes: { a: ["href", "target"] },
  })
}

const ArchiveWithData = (props) => {
  return <Archive {...props} />
}

export default ArchiveWithData
